import {Grid, Typography, Link} from "@mui/material";

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Formulario_Portada_Home from "./Componentes/SubComponentes/Formulario_Portada_Home";

const contacto = [
    {
        icon: <WhatsAppIcon/>,
        label: "304 586 5692",
        href: "https://wa.me/573045865692?text=Hola,%20quiero%20mas%20informacion."
    },
    {icon: <LinkedInIcon/>, label: "/  diego-polo-tecnologia", href: "https://www.linkedin.com/in/diego-polo-tecnologia/"},
    {
        icon: <LocationOnIcon/>,
        label: "Colombia",
        href: "https://www.google.com/maps/place/Colombia/@5.9219139,-74.3390061,3752249m/data=!3m2!1e3!4b1!4m6!3m5!1s0x8e15a43aae1594a3:0x9a0d9a04eff2a340!8m2!3d4.570868!4d-74.297333!16zL20vMDFsczI?entry=ttu&g_ep=EgoyMDI1MDgyNS4wIKXMDSoASAFQAw%3D%3D"
    },


];

const Seccion_Contacto = () => {

    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container justifyContent={'flex-start'} size={{xs: 12, sm: 12, md: 11}}
                  sx={{maxWidth: 1400, px: 3, pt: sCell ? 16 : 16}}>
                <Grid container
                      justifyContent={'flex-start'}
                      size={{xs: 12, sm: 12, md: 12}} sx={{pb:4}}>
                    <Typography variant="h3">Contacto</Typography>
                </Grid>


                <Grid item
                      justifyContent={'flex-start'}
                      size={{xs: 12, sm: 12, md: 6}}
                >

                    <Grid container justifyContent={'flex-start'} size={{xs: 12, sm: 12, md: 12}}>
                        <ul style={{
                            listStyle: "none", display: "flex",
                            gap: '16px',
                            flexDirection: "column",
                            margin: 0,
                            padding: 0,
                        }}>
                            {contacto.map((item, index) => (

                                <li key={index}>
                                    <Typography variant={'body1'}>
                                        <Link
                                            title={`Ir a ${item.label}`}
                                            href={item.href}
                                            underline="none"
                                            sx={{
                                                width: '100%',
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                fontSize: "1rem",
                                                fontWeight: 500,
                                                color: "text.primary",
                                                "&:hover": {color: "primary.main"},
                                            }}
                                        >

                                            {item.icon}

                                            {item.label}


                                        </Link>
                                    </Typography>
                                </li>
                            ))}
                        </ul>
                    </Grid>


                </Grid>
                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <Formulario_Portada_Home/>
                </Grid>


            </Grid>
        </Grid>
    )

}
export default Seccion_Contacto